(() => {
  if (customElements.get('ef-inventory-carousel')) return;

  class EfInventoryCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');
      this.currentEl = this.querySelector('[data-current]');
      this.totalEl = this.querySelector('[data-total]');

      if (!this.track) return;

      this.items = Array.from(this.track.children);
      if (this.items.length === 0) return;

      this.prevBtn?.addEventListener('click', () => this.scrollByPage(-1));
      this.nextBtn?.addEventListener('click', () => this.scrollByPage(1));

      this.track.addEventListener('scroll', () => this.updateState(), { passive: true });
      window.addEventListener('resize', () => this.updateState(), { passive: true });

      this.updateState();
    }

    getStep() {
      if (!this.items[0]) return 0;
      const itemWidth = this.items[0].getBoundingClientRect().width;
      const styles = window.getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return itemWidth + gap;
    }

    getCardsPerView() {
      const step = this.getStep();
      if (!step) return 1;
      return Math.max(1, Math.round(this.track.clientWidth / step));
    }

    scrollByPage(direction) {
      const step = this.getStep();
      const cardsPerView = this.getCardsPerView();
      if (!step) return;
      this.track.scrollBy({
        left: direction * step * cardsPerView,
        behavior: 'smooth',
      });
    }

    updateState() {
      const step = this.getStep();
      if (!step) return;

      const cardsPerView = this.getCardsPerView();
      const total = this.items.length;
      const totalPages = Math.max(1, Math.ceil(total / cardsPerView));
      const scrollLeft = this.track.scrollLeft;
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const currentPage = Math.min(totalPages, Math.floor(scrollLeft / (step * cardsPerView)) + 1);

      if (this.currentEl) this.currentEl.textContent = String(currentPage);
      if (this.totalEl) this.totalEl.textContent = String(totalPages);

      const atStart = scrollLeft <= 1;
      const atEnd = scrollLeft >= maxScroll - 1;
      if (this.prevBtn) this.prevBtn.disabled = atStart;
      if (this.nextBtn) this.nextBtn.disabled = atEnd;
    }
  }

  customElements.define('ef-inventory-carousel', EfInventoryCarousel);
})();
